import React, { Component } from 'react';

import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';

export default class SelectScaler extends Component<any> {
  static defaultProps = {
    placeholder: 'Select scaler email',
  };

  fetchScalers = async (email: string) => {
    if (!email) {
      return (async () => [])();
    }
    try {
      const query = {
        search: email.replaceAll('.', '\\.').replaceAll('+', '\\+'),
        email: true,
      };
      const { users } = await apiFetch(null, `corp-api/find/scalers`, { query });
      return {
        options: users.map((user: any) => ({
          label: user.email,
          value: user.id,
        })),
      };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
    }
    return [];
  };

  render() {
    return (
      <div>
        <Select filterOption={() => true} loadOptions={this.fetchScalers} {...this.props} />
      </div>
    );
  }
}
